import { Button, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { NotesModalType } from "../../../../../Types/MessengerType";

const FavoriteModal: React.FC<NotesModalType> = ({ toggle, modal }) => {
  return (
    <Modal fade className="fev-addcall-main add-popup" isOpen={modal} toggle={toggle}>
      <ModalHeader>
        Add Contact
        <Button className="close" onClick={toggle}><span>×</span></Button>
      </ModalHeader>
      <ModalBody>
        <Form className="default-form">
          <div className="form-group text-center">
            <h5>Email or Username</h5>
            <Input type="text" placeholder="Josephin water" />
          </div>
          <div className="form-group text-center">
            <h5>Contact number</h5>
            <Input type="number" placeholder={"12345678912"} />
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" className="button-effect btn-sm" onClick={toggle}>Cancel</Button>
        <Button color="primary" className="button-effect btn-sm">Add contact</Button>
      </ModalFooter>
    </Modal>
  );
};

export default FavoriteModal;
